import * as React from "react"
import {
  MainContainer,
  InnerContainer,
  Section,
  LeftBlock,
  Heading,
  RightBlock,
  SubHeading,
} from "./styles"
import { BsMicFill } from "react-icons/bs"
import { FaLightbulb } from "react-icons/fa"
import { FaNetworkWired } from "react-icons/fa"
import { FaHotel } from "react-icons/fa"
import { TiGroup } from "react-icons/ti"
import { AiFillSafetyCertificate } from "react-icons/ai"
import { Heading as Mainheading } from "../../components/ScientificSessions/sessionstyles"

const whyattend = () => {
  const points = [
    {
      icon: <BsMicFill color="#fff" size="2rem" />,
      heading: "World Class Speakers",
      subHeading: "",
    },
    {
      icon: <FaLightbulb color="#fff" size="2rem" />,
      heading: "Best Experience",
      subHeading: "",
    },
    {
      icon: <FaNetworkWired color="#fff" size="2rem" />,
      heading: "Networking",
      subHeading: "",
    },
    {
      icon: <FaHotel color="#fff" size="2rem" />,
      heading: "Modern Venue",
      subHeading: "",
    },
    {
      icon: <TiGroup color="#fff" size="2rem" />,
      heading: "New People",
      subHeading: "",
    },
    {
      icon: <AiFillSafetyCertificate color="#fff" size="2rem" />,
      heading: "Certificates",
      subHeading: "",
    },
  ]

  return (
    <MainContainer>
      <Mainheading whyattend style={{ marginBottom: "50px" }}>
        Why will a global community gather in London?
      </Mainheading>
      <InnerContainer>
        {points.map((node, index) => (
          <Section>
            <LeftBlock>{node.icon}</LeftBlock>
            <RightBlock>
              <Heading>{node.heading}</Heading>
              <SubHeading>
                At vero eos et accusamus et iusto odio dignissimos ducimus qui
                blanditiis praesentium voluptatum deleniti atque.
              </SubHeading>
            </RightBlock>
          </Section>
        ))}
      </InnerContainer>
    </MainContainer>
  )
}

export default whyattend
